import { FormattedMessage } from 'react-intl'

export const CloseButtonLabel = () => <FormattedMessage id="shared.close_button_label" />
